import { html } from 'htm/preact'
import { useState } from 'preact/hooks'
import { money } from '../units.js'

export default function PortionCalc({ totalCost, recipe, id }) {
  const recipeId = id || 'new'
  const [customPortions, setCustomPortions] = useState(() => sessionStorage.getItem(`mc_cp_${recipeId}`) || '')

  const {
    total_batch_weight_kg: tbwk,
    serving_size_grams: ssg,
    sales_unit: su,
    pieces_per_sale_unit: ppsu,
  } = recipe || {}

  const effectivePpsu = (su === 'piece' && !ppsu) ? 1 : ppsu
  const costPerPiece = effectivePpsu ? totalCost / effectivePpsu : null
  const costPerKg = tbwk ? totalCost / tbwk : null
  const costPerServing = (ssg && tbwk) ? (totalCost / tbwk) * (ssg / 1000) : null
  const costPerTray = (su === 'tray' && ppsu) ? totalCost : null

  const customN = parseFloat(customPortions)
  const isWeightMode = su === 'weight' && costPerKg != null && costPerServing == null
  let customCost = null
  if (Number.isFinite(customN) && customN > 0) {
    if (costPerServing != null) {
      customCost = costPerServing * customN
    } else if (isWeightMode) {
      customCost = costPerKg * customN
    } else if (costPerPiece != null) {
      customCost = costPerPiece * customN
    }
  }

  return html`
    <div class="cost-card">
      <p class="cost-card__label">Cost breakdown</p>

      <div class="cost-card__total">
        <span>Total</span>
        <strong>${money(totalCost)}</strong>
      </div>

      <div class="cost-card__divider"></div>

      <div class="cost-card__rows">
        ${costPerPiece != null && html`
          <div class="cost-row">
            <span>Per piece</span>
            <span>${money(costPerPiece)}</span>
          </div>
        `}
        ${costPerKg != null && html`
          <div class="cost-row">
            <span>Per kg</span>
            <span>${money(costPerKg)}</span>
          </div>
        `}
        ${costPerServing != null && html`
          <div class="cost-row">
            <span>Per serving (${ssg}g)</span>
            <span>${money(costPerServing)}</span>
          </div>
        `}
        ${costPerTray != null && html`
          <div class="cost-row">
            <span>Per tray (${ppsu} pcs)</span>
            <span>${money(costPerTray)}</span>
          </div>
        `}
        ${costPerPiece == null && costPerKg == null && costPerServing == null && costPerTray == null && html`
          <div class="cost-row">
            <span>Add production details above</span>
            <span></span>
          </div>
        `}
      </div>

      <div class="cost-card__divider"></div>

      <div class="cost-custom">
        <p class="cost-custom__label">Custom portions</p>
        <div class="cost-custom__row">
          <input
            class="input cost-custom__input"
            type="number"
            min="0.01"
            step="0.1"
            placeholder=${costPerServing != null ? 'e.g. 2' : isWeightMode ? 'e.g. 2.5' : 'e.g. 25'}
            value=${customPortions}
            onInput=${e => {
              const val = e.target.value
              setCustomPortions(val)
              sessionStorage.setItem(`mc_cp_${recipeId}`, val)
            }}
          />
          <span class="cost-custom__sep">${costPerServing != null ? 'servings' : isWeightMode ? 'kg' : 'portions'}</span>
          <span class="cost-custom__result">
            ${customCost != null ? money(customCost) : html`<span class="cost-custom__placeholder">= $—</span>`}
          </span>
        </div>
      </div>
    </div>
  `
}
